import { FormGroup } from "@blueprintjs/core";
import { IconNames } from "@blueprintjs/icons";
import React from "react";

import ButtonSelect from "common/form/widgets/common/ButtonSelect";
import TextWidget from "common/form/widgets/TextWidget";
import Icon from "common/views/icon/Icon";
import Label from "core/components/label/Label";
import TokenSession from "core/util/session/TokenSession";
import { ILinkType, IStaticLinkData, LinkTypeRegistry } from "../ILinkType";
import { IMenuNode } from "../MenuTree.view";

interface IContainerLink extends IStaticLinkData {
	anonymousLabel: string;
}

const containerLinkType: ILinkType<IContainerLink> = {
	type: "container:welcome",
	label: "Welcome User Container",
	icon: IconNames.USER,
	renderInput: (value: IContainerLink, onChange: (value: IContainerLink) => void) => (
		<React.Fragment>
			<FormGroup label="Label (Logged In)">
				<TextWidget onChange={(label) => onChange({...value, label})} value={value.label} />
			</FormGroup>
			<FormGroup label="Label (Not Logged In)">
				<TextWidget onChange={(anonymousLabel) => onChange({...value, anonymousLabel})} value={value.anonymousLabel} />
			</FormGroup>
			<FormGroup label="Icon">
				<TextWidget onChange={(icon) => onChange({...value, icon})} value={value.icon} />
			</FormGroup>
			<FormGroup label="Icon Type">
				<ButtonSelect
					onChange={(iconType: "bp" | "external") => onChange({...value, iconType})}
					options={[
						{value: "bp", label: "Blueprint"},
						{value: "external", label: "External"}
					]}
					value={value.iconType || "bp"}
				/>
			</FormGroup>
		</React.Fragment>
	),
	mapDataToMenuNode: (data: IContainerLink, props): IMenuNode<IContainerLink> => {

		const user = TokenSession.getUser();

		return {
			...props,
			label: user ? (
				<Label
					k="link.welcome"
					v={data.label || "${name}"}
					args={{
						name: user.firstName + ' ' + user.lastName,
						firstName: user.firstName,
						lastName: user.lastName
					}}
				/>
			) : (
				<Label
					k={`link.welcome.anonymous`}
					v={data.anonymousLabel || "Welcome"}
				/>
			),
			icon: <Icon icon={data.icon} />,
			isSelectable: false
		};
	}
};

export default LinkTypeRegistry.registerType(containerLinkType);



// WEBPACK FOOTER //
// ./src/common/views/menuTree/linkTypes/WelcomeContainerLink.tsx